<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    <OperatorStore ref="operatorStore"/>
    
    <!-- Sync not needed yet -->
    <!-- <TwilioSyncStore service="tcportalAdmin" ref="twilioSyncStore"/> -->
    <!-- ///////////////////////////////////////// -->

    <h1>Operator Page (work in progress)</h1>
    
    <TCUsers />
    <TCVehicles />
    <Operators />
    
  </div>
</template>

<script>

import OperatorStore from './Stores/OperatorStore.vue'
import TwilioSyncStore from '../Phone/Stores/TwilioSyncStore.vue'

import TCUsers from './Components/TCUsers.vue'
import TCVehicles from './Components/TCVehicles.vue'
import Operators from './Components/Operators.vue'

export default {
  name:"OperatorsPage",
  components: {TCUsers, TCVehicles, Operators,        TwilioSyncStore, OperatorStore},
  data () { return {
    syncClient: undefined,
  }},
  provide() {
    return {
      operatorPage: this
    }
  },
  async mounted(){
    // this.$options.provide = {callStore: this.$refs.callStore}
    // this.$set(this.$options.provide, 'callStore' ,this.$refs.callStore)
    // console.log(this.$options.provide)
    // this.callStore = this.$refs.callStore;
     
     //TODO Twilio sync code should be lazy loaded

      const syncTokenURL = `https://fandango-wombat-7897.twil.io/sync_access_token?k=${this.$_auid}`
      const r = await axios.get(syncTokenURL)
      this.syncClient = new Twilio.Sync.Client(r.data.token);
      
      this.syncClient.on('tokenAboutToExpire', async () => {
        console.log('Updating Token')
        const r = await axios.get(syncTokenURL)
        this.syncClient.updateToken(r.data.token);
      }); 
  },
  
  
}
</script>

<style scoped>

</style>